import { Student } from '@/models/Student'
import { StudentRepository } from '@/repository/StudentRepository'
import { ParentRepository } from '@/repository/ParentRepository'

import { StudentAgeError } from './errors'

class UpdateStudent {
  constructor(client, student) {
    if (!(client)) {
      throw new Error(`'client' is required.`)
    }
    if (!(student instanceof Student)) {
      throw new TypeError(`'student' must be an instance of [object Parent]. Actual: ${typeof student}`)
    }
    this.updater = UpdateStudentFactory.create(client, student)
  }

  async execute(values) {
    return await this.updater.execute(values)
  }
}

class UpdateStudentFactory {
  static create(client, student) {
    return new ParentUpdateStudent(client, student)
  }
}

class ParentUpdateStudent {
  constructor(client, student) {
    this.student = student
    this.parentRepo = new ParentRepository(client)
    this.studentRepo = new StudentRepository(client)
  }

  async execute(values) {
    this._validateValues(values)
    let parent = await this.parentRepo.find(this.student.getParentId())
    return await this.parentRepo.update(parent.updateStudent(await this.studentRepo.update(new Student(Object.assign(this.student, values)))))
  }

  _validateValues(values) {
    try {
      Student.validateGrade(values.birthday)
    } catch (e) {
      if (e instanceof RangeError) {
        throw new StudentAgeError(`小学生から高校生までに該当する年齢の方のみ登録可能です。`)
      } else {
        throw new Error(`予期せぬエラーが発生しました。`)
      }
    }
  }
}

export  { UpdateStudent }